import React from 'react';
import { useIntl } from 'react-intl';
import { useAtomValue } from 'jotai';
import { Box, Typography, Divider, Chip, Tooltip } from '@mui/material';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import TreeNode from './TreeNode';
import { ROOT_ID, validationAtom } from '../store/schemaAtoms';
import {
  CenteredFlexBox,
  FullSizeCenteredFlexBox,
  FullSizeColumn,
} from '../../../../../Components/FlexBox';

const TreePane = function TreePane() {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });
  const { errors, isValid } = useAtomValue(validationAtom);

  const issueLabel = intl.formatMessage(
    { id: 'SCHEMA_ISSUES' },
    { count: errors.length }
  );

  return (
    <FullSizeColumn>
      <CenteredFlexBox justifyContent="space-between" padding="8px" gap="8px">
        <AccountTreeRoundedIcon fontSize="small" sx={{ color: '#314cb6' }} />
        <Typography
          variant="overline"
          sx={{
            fontWeight: 700,
            letterSpacing: '0.08em',
            color: '#314cb6',
            flexGrow: 1,
          }}
        >
          {t('SCHEMA_STRUCTURE')}
        </Typography>
        <Tooltip
          title={errors
            .map((e) => {
              const key = `SCHEMA_ERR_${e.message}`;
              return intl.messages[key] ? t(key) : e.message;
            })
            .join(', ')}
          placement="top"
        >
          <Chip
            size="small"
            icon={
              isValid ? (
                <CheckCircleRoundedIcon fontSize="small" color="inherit" />
              ) : (
                <ErrorOutlineRoundedIcon fontSize="small" color="inherit" />
              )
            }
            label={isValid ? t('SCHEMA_VALID') : issueLabel}
            sx={{
              height: 22,
              fontWeight: 600,
              backgroundColor: isValid
                ? 'rgba(46, 125, 50, 0.06)'
                : 'rgba(192, 57, 43, 0.06)',
              color: isValid ? '#2e7d32' : '#c0392b',
            }}
          />
        </Tooltip>
      </CenteredFlexBox>
      <Divider />
      <TreeNode id={ROOT_ID} depth={0} indexInParent={0} />
    </FullSizeColumn>
  );
};

export default TreePane;
